import { Box, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { getUser } from '../../../utils/cookie';

import MetaTags from '../../../components/MetaTags';
import { Heading2 } from '../../../components/Heading';
import { CustomButton } from '../../../components/Buttons';
import FooterMenu from '../../../components/Footer/FooterMenu';

const SignedIn = () => {
  const navigate = useNavigate();
  const user = getUser();

  useEffect(() => {
    if (!user) {
      navigate('/signin', { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!user) return null;

  return (
    <Box>
      <MetaTags title="Black Box VR - Signed In!" />
      <Box position="relative" display="flex" justifyContent="center" mb={20}>
        <Box maxWidth={618} width="100%" mt={8} px={2}>
          <Heading2>YOU ARE SIGNED IN!</Heading2>
          <Typography mt={2}>
            {user.username ? (
              <>
                You are signed in as <b>{user.username}</b>. Where to next?
              </>
            ) : (
              'You are signed in. Where to next?'
            )}
          </Typography>
          <Box display="flex" gap={2} mt={4} flexWrap="wrap">
            {user.username && (
              <CustomButton href={`/member/${user.username}`}>View My Profile</CustomButton>
            )}
            <CustomButton href="/">Go to the Community Feed</CustomButton>
          </Box>
        </Box>
      </Box>
      <FooterMenu />
    </Box>
  );
};

export default SignedIn;
